import { Typography } from '@material-ui/core'
import React from 'react'

interface IProps {
  label: ReactNode | string
}

export const InfoLine: React.FC<IProps> = ({ label, children }) => {
  return (
    <Typography variant="body2">
      {label}: <b>{children}</b>
    </Typography>
  )
}
